export default function Cross({ color='var(--accent)', ...props }) {
	return <svg width="22" height="21" {...props} viewBox="0 0 22 21" xmlns="http://www.w3.org/2000/svg" fill="none">
		<path d="M2.5 2L20 19M2 19L20 2" stroke={color} strokeWidth="4" strokeLinecap="round"/>
	</svg>
}